import { render, staticRenderFns } from "./aws-cognito-login.vue?vue&type=template&id=f607c6d6&"
import script from "./aws-cognito-login.vue?vue&type=script&lang=js&"
export * from "./aws-cognito-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aws-cognito-login.vue"
export default component.exports